import { render } from "./AICG.vue?vue&type=template&id=ef05e588&scoped=true"
import script from "./AICG.vue?vue&type=script&lang=js"
export * from "./AICG.vue?vue&type=script&lang=js"

import "./AICG.vue?vue&type=style&index=0&id=ef05e588&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef05e588"]])

export default __exports__